import styled from 'styled-components';
import { getFontStyles } from '@/redux/cmsConfig/utils';

export const OrganizationLabel = styled.div(({ theme }) => ({
  ...getFontStyles(theme.header.font, ['font_family', 'font_size', 'color']),
  '@media only screen and (max-width: 600px)': {
    textAlign: 'center',
  },
}));
